import { Device } from '@capacitor/device';
import { type AppLanguage } from 'src/stores/userInterfaceSettings/state';

import { isRunningInNativeCapacitorApp } from 'src/util/platform/browserInteractionCapabilities';

export const detectLocale = async (): Promise<string> => {
	try {
		if (!isRunningInNativeCapacitorApp()) {
			const browserLanguage: null | string = navigator.languages[0].toLowerCase();
			switch (browserLanguage) {
				case 'de':
					return browserLanguage + '-DE';
				case 'en':
					return browserLanguage + '-US';
				default:
					return 'de-DE';
			}
		} else {
			const languageCode = await Device.getLanguageCode();

			switch (languageCode.value) {
				case 'de':
					return languageCode.value + '-DE';
				case 'en':
					return languageCode.value + '-US';
				default:
					return 'de-DE';
			}
		}
	} catch {
		return 'de-DE';
	}
};

export async function resolveLocaleForLanguagePreference(preference: AppLanguage): Promise<string> {
	if (preference === 'de') {
		return 'de-DE';
	}

	if (preference === 'en') {
		return 'en-US';
	}

	return detectLocale();
}
